module.exports = __webpack_public_path__ + "static/img/shiquanshimei_ma.66136b52.png";